<template>
  <section v-show="isDisplayed" class="sticky-footer">
    <div class="group -vs-xsmall">
      <a
        class="btn -alt"
        :href="url"
        :target="target"
        :rel="rel"
        :data-action="eventAction"
        :data-category="eventCategory"
        :data-label="eventLabel"
        @click="clickTracking"
        >{{ title }}</a
      >
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onBeforeUnmount, onMounted } from 'vue'
import _debounce from 'lodash/debounce'
import { trackLink } from '@/utils/analytics'

/** PROPS **/
const props = withDefaults(
  defineProps<{
    title: string
    url: string
    offsetHeaderId: string
    target?: string
    rel?: string
    trackEvent?: boolean
    eventAction?: string
    eventCategory?: string
    eventLabel?: string
  }>(),
  {
    target: '',
    rel: '',
    trackEvent: false,
    eventAction: '',
    eventCategory: '',
    eventLabel: '',
  },
)

/** STATE **/
const isDisplayed = ref(false)
const heroRef = document.querySelector(`#${props.offsetHeaderId}`) as HTMLElement
const eventTracked = ref(false)

/** COMPUTED **/
// none

/** LIFECYCLE **/
onMounted(() => {
  // add event listener to show / hide based on scroll position
  document.addEventListener('scroll', showFixedButton)

  // also run once
  showFixedButton()
})

onBeforeUnmount(() => {
  // clean up
  document.removeEventListener('scroll', showFixedButton)
})

/** METHODS **/
const showFixedButton: () => void = _debounce(() => {
  const heroHeight = heroRef.offsetHeight
  const scrollY = window.scrollY || window.pageYOffset

  if (scrollY > heroHeight && !isDisplayed.value) {
    isDisplayed.value = true
  } else if (scrollY < heroHeight && isDisplayed.value) {
    isDisplayed.value = false
  }
}, 50)

function clickTracking(e: MouseEvent) {
  // ga event tracking
  if (props.trackEvent && !eventTracked.value) {
    trackLink(e)
  }

  eventTracked.value = true
}
</script>
